'use strict';
angular.module('reporting.dashboards.services')
    .factory('$exceptionHandler', ['$injector', function ($injector) {
        return function (exception) {
            if (console.groupCollapsed) {
                console.groupCollapsed('%c [Unhandled Exception] %c ' + exception.message, 'background-color: red; color: white; font-weight: normal;', 'color: red; font-weight: normal');
                console.log('%c' + exception.stack, 'color: red');
                console.groupEnd();
            }
            else {
                console.error(exception.message);
            }
            var log = $injector.get('log');
            log.error(exception.message);
        };
    }]);
